import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import classnames from 'classnames'
import { Button, IconButton } from '@material-ui/core'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import ContextMenu from './ContextMenu'
import ClampedText from './ClampedText'
import connectPropTypes from '../utilities/connectPropTypes'
import styles from './Comment.icss'

class Comment extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			showContextMenu: false,
			showDeleteDialog: false
		}
		this.contextEl = React.createRef()
		this.handleDelete = this.handleDelete.bind(this)
		this.handleReport = this.handleReport.bind(this)
		this.bindActionAndClose = this.bindActionAndClose.bind(this)
		this.handleContextClose = this.handleContextClose.bind(this)
		this.handleContextOpen = this.handleContextOpen.bind(this)
		this.handleDeleteDialogClose = this.handleDeleteDialogClose.bind(this)
		this.handleDialogDelete = this.handleDialogDelete.bind(this)
	}

	handleContextClose() {
		this.setState({ showContextMenu: false })
	}

	handleContextOpen() {
		this.setState({ showContextMenu: true })
	}

	handleDeleteDialogClose() {
		this.setState({ showDeleteDialog: false })
	}

	handleDialogDelete() {
		const { commentId } = this.props.comment
		this.handleDeleteDialogClose()
		this.props.commentDelete(commentId)
	}

	bindActionAndClose(action) {
		const { commentId } = this.props.comment
		return () => {
			this.handleContextClose()
			action(commentId)
		}
	}

	handleDelete() {
		this.setState({ showDeleteDialog: true })
	}

	handleReport(commentId) {
		this.props.appRedirect(`/report?url=${global.encodeURIComponent(`${global.location.href}#comment-${commentId}`)}`)
	}

	render() {
		const { comment, commentDelete, clamped, highlight, className, showContextMenu } = this.props
		if (!comment) {
			return null
		}
		const { text, userName, createdTimestamp, commentId } = comment
		return (
			<section id={`comment-${commentId}`} style={{ scrollBehavior: 'smooth' }} className={classnames(styles.comment, highlight ? styles.highlight : null, className)}>
				<div className={styles.surround}>
					<div className={styles.text}>
						{clamped && (
							<ClampedText numLines={5}>
								{userName && <span className={styles.userName}>{userName}</span>}
								{text}
							</ClampedText>
						)}
						{!clamped && (
						<>
							{userName && <span className={styles.userName}>{userName}</span>}
							{text}
						</>
						)}
					</div>
					{showContextMenu && commentId && (
						<>
							<div>
								<IconButton aria-label="Context" onClick={this.handleContextOpen}>
									<span ref={this.contextEl} />
									<MoreVertIcon />
								</IconButton>
							</div>
							{this.state.showContextMenu && (
								<ContextMenu
									contextMenuItems={[
										{
											name: this.context.translate('Report'),
											handler: this.handleReport
										},
										...(commentDelete ? [{
											name: this.context.translate('Delete'),
											handler: this.handleDelete
										}] : [])
									]}
									handleContextClose={this.handleContextClose}
									anchorEl={this.contextEl.current}
									menuItemClickBinder={this.bindActionAndClose}
									item={{ commentId }}
								/>
							)}
						</>
					)}
				</div>
				{createdTimestamp && (
					<div className={styles.timestamp}>
						{moment(createdTimestamp).fromNow()}
					</div>
				)}
				<Dialog
					open={this.state.showDeleteDialog}
					onClose={this.handleDeleteDialogClose}
					aria-labelledby="alert-dialog-title"
					aria-describedby="alert-dialog-description"
				>
					<DialogTitle id="alert-dialog-title">{this.context.translate('Delete comment?')}</DialogTitle>
					<DialogContent>
						<DialogContentText id="alert-dialog-description">
							{this.context.translate('Do you want to keep the comment, or delete it?')}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button onClick={this.handleDialogDelete} color="primary">
							{this.context.translate('Delete')}
						</Button>
						<Button onClick={this.handleDeleteDialogClose} color="primary" autoFocus>
							{this.context.translate('Keep comment')}
						</Button>
					</DialogActions>
				</Dialog>
			</section>
		)
	}
}

Comment.contextTypes = {
	translate: PropTypes.func
}

Comment.propTypes = {
	comment: PropTypes.shape({
		commentId: PropTypes.string,
		text: PropTypes.string,
		userName: PropTypes.string,
		uid: PropTypes.string,
		createdTimestamp: PropTypes.number // eslint-disable-line react/forbid-prop-types
	}).isRequired,
	clamped: PropTypes.bool,
	highlight: PropTypes.bool,
	className: PropTypes.string,
	showContextMenu: PropTypes.bool,
	commentDelete: PropTypes.func,
	user: PropTypes.shape({
		uid: PropTypes.string,
		isAdmin: PropTypes.bool
	}).isRequired,
	appRedirect: PropTypes.func.isRequired
}

Comment.defaultProps = {
	clamped: false,
	highlight: false,
	className: undefined,
	showContextMenu: true,
	commentDelete: undefined
}

export const testing = {
	Comment
}

export default connectPropTypes(Comment)



// WEBPACK FOOTER //
// ./src/components/Comment.jsx